import { styles } from "../../styles";
import { noImageWoman, noImageMan } from "../../assets";

const LectureProfileCard = (props) => {
  return (
    <div className="flex flex-col items-center h-fit md:scale-[0.8] sm:scale-[0.6]">
      <div className="mt-10 relative rounded-tl-[125px] rounded-br-[125px] bg-primary-40 w-[250px] h-[250px] sm:mt-[-40px]">
        <div className="absolute bottom-0">
          <img
            src={props.image || (props.gender.toLowerCase() === "female" ? noImageWoman : noImageMan)}
            alt={props.name}
            className="rounded-br-[125px]"
          />
        </div>
      </div>
      <p
        className={`${styles.headingS} mt-4 text-primary-40 w-[400px] text-center`}
      >
        {props.name}
      </p>
      <p className={`${styles.textMMedium} w-[300px] mt-2 text-center`}>
        {props.role}
      </p>
    </div>
  );
};

export default LectureProfileCard;
